export const DEFAULT_TIMEZONE = "Asia/Jakarta";

/**
 * Returns the business calendar date formatted as YYYY-MM-DD
 * for a given IANA timezone and optional reference date/instant.
 *
 * Uses native Intl.DateTimeFormat with 'en-CA' locale which outputs YYYY-MM-DD.
 */
export function getBusinessDate(
  timezone: string = DEFAULT_TIMEZONE,
  date: Date | number | string = new Date()
): string {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) {
    throw new Error(`INVALID_DATE_FORMAT: Invalid date supplied to getBusinessDate: ${date}`);
  }

  const validTz = isValidTimeZone(timezone) ? timezone : DEFAULT_TIMEZONE;

  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: validTz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return formatter.format(d);
}

/**
 * Validates if an IANA timezone identifier is supported by the runtime environment.
 */
export function isValidTimeZone(tz: string): boolean {
  if (!tz || typeof tz !== "string") return false;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch {
    return false;
  }
}
